module.exports = __webpack_public_path__ + "static/media/boost_logo.dda216f5.png";